/* eslint-disable node/prefer-global/process */
import type { FetchContext, FetchOptions } from 'ofetch'
import { ResultEnum } from '~/enums/interface'
import { refreshToken } from '~/server/common'

// 默认 - 响应拦截器
export function onResponse({ response }: FetchContext): Promise<void> | void {
  // const data = response?._data
  // if (process.server)

  // console.log('response._data', JSON.stringify(data))
}

// api5 - 响应错误处理
function onApi5Response({ request, options, response }: FetchContext): Promise<void> | void {
  // console.log(response, 'onApi5Response')
  const data = response?._data
  onResponse({ request, options, response })
  // 如果不是服务端请求且未登录则跳转到登陆页面
  if (!process.server && data.code === ResultEnum.NOTLOGININ) {
    const route = useRoute()
    window.location.href = `/member/mobileLogin?redirect=${route.fullPath}`
  }
  /**
   * 针对api4某些接口反馈数据中不存在code，则默认返回200【和xjc沟通后，xjc决策】
   */
  if (!Object.hasOwn(data, 'code')) {
    data.code = '200'
  }
  if (!ResultEnum.SUCCESS.split(',').includes(data?.code?.toString())) {
    if (data.code === 1602005) { // 判定为用户accessToken过期，但是大部分接口不需要用户登录，这个状态的时候不应该弹框提示，所以走到这里的时候不做提示，刷新下accessToken
      refreshToken() // 刷新方法
      console.error('请注意，用户未登录')
      return
    }
    else if ([1407001, 1407002, 1407003].includes(data.code)) { // 隐私号异常，不需要弹窗报错
      return
    }
    message.error({
      content: data.message,
      duration: 3,
      key: 'global-error',
    })
  }
}

/**
 * api5 请求
 */
export function useRequest() {
  const nuxt = useNuxtApp()
  const { public: { apiBase } } = useRuntimeConfig()

  const baseOption = {
    baseURL: apiBase,
    onResponse: (ctx: FetchContext) => onApi5Response(ctx),
  }

  return {
    get: (url: string, params?: Record<string, any>, option?: Omit<FetchOptions, 'url' | 'method'>) => {
      return nuxt.$http(url, { params, method: 'get', ...baseOption, ...option })
    },
    post: (url: string, body?: any, option?: Omit<FetchOptions, 'url' | 'method'>) => {
      return nuxt.$http(url, { body, method: 'post', ...baseOption, ...option })
    },
  }
}

/**
 * api4 - 响应错误处理
 * TODO
 */
// function onApi4Response({ request, options, response }: FetchContext): Promise<void> | void {
// console.log(response, 'onApi4Response')
// const route = useRoute()
// const data = response?._data
// onResponse({ request, options, response })
// // 如果不是服务端请求且未登录则跳转到登陆页面
// if (!process.server && data.code === ResultEnum.NOTLOGININ)
//   window.location.href = `/member/mobileLogin?redirect=${route.fullPath}`
// if (!ResultEnum.SUCCESS.split(',').includes(data?.code?.toString())) {
//   console.log(request, 'request')
//   console.log(data, 'data')
//   message.error({
//     content: data.message,
//     duration: 3,
//     key: 'global-error',
//   })
// }
// }

/**
 * api4 请求
 */
export function useRequestApi4() {
  const nuxt = useNuxtApp()

  const { public: { api4 } } = useRuntimeConfig()
  const baseOption = {
    baseURL: api4,
    // onResponse: (ctx: FetchContext) => onApi4Response(ctx),
  }

  return {
    get: (url: string, params?: Record<string, any>, option?: Omit<FetchOptions, 'url' | 'method'>) => {
      return nuxt.$http(url, { params, method: 'get', ...baseOption, ...option })
    },
    post: (url: string, body?: any, option?: Omit<FetchOptions, 'url' | 'method'>) => {
      return nuxt.$http(url, { body, method: 'post', ...baseOption, ...option })
    },
  }
}

/**
 * 直接请求
 */
export function useRequestDirect() {
  const nuxt = useNuxtApp()

  return {
    get: (url: string, params?: Record<string, any>, option?: Omit<FetchOptions, 'url' | 'method'>) => {
      return nuxt.$http(url, { params, method: 'get', ...option, mode: 'no-cors' })
    },
    post: (url: string, body?: any, option?: Omit<FetchOptions, 'url' | 'method'>) => {
      return nuxt.$http(url, { body, method: 'post', ...option, mode: 'no-cors' })
    },
  }
}
